(function () {
  function parseJsonScript(id) {
    var node = document.getElementById(id);
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      console.error("ChargePapa guide JSON parse failed", error);
      return null;
    }
  }

  function ready(fn) {
    if (document.readyState !== "loading") {
      fn();
    } else {
      document.addEventListener("DOMContentLoaded", fn);
    }
  }

  ready(function () {
    var guides = document.querySelectorAll("[data-cp-guide]");

    guides.forEach(function (root) {
      var sectionId = root.getAttribute("data-section-id");
      var options = parseJsonScript("CpGuideOptions-" + sectionId);
      var resultCards = parseJsonScript("CpGuideResults-" + sectionId) || [];
      if (!options) return;

      var selections = {
        scenario: "",
        vehicle: "",
        source: ""
      };

      function activeStageIndex() {
        if (!selections.scenario) return 0;
        if (!selections.vehicle) return 1;
        if (!selections.source) return 2;
        return 3;
      }

      function getVehicleOptions() {
        if (!selections.scenario) return [];

        var allowByScenario = {
          home_station: ["j1772", "nacs", "type2"],
          portable_charger: ["j1772", "nacs", "type2"],
          adapter: ["j1772", "nacs", "type2", "ccs1", "ccs2"]
        };

        var allow = allowByScenario[selections.scenario] || [];
        return (options.vehicle || []).filter(function (item) {
          return allow.indexOf(item.value) !== -1;
        });
      }

      function sourceKey() {
        if (!selections.scenario || !selections.vehicle) return "";
        return selections.scenario + "__" + selections.vehicle;
      }

      function getSourceOptions() {
        var key = sourceKey();
        if (!key) return [];
        return options.source[key] || [];
      }

      function inferredUseCase() {
        if (selections.scenario === "home_station") return "home_ac";
        if (selections.scenario === "portable_charger") return "home_ac";
        if (selections.scenario === "adapter") {
          if (
            selections.source === "ccs1_station" ||
            selections.source === "ccs2_station" ||
            selections.source === "nacs_dc_station"
          ) {
            return "dc_fast";
          }
          return "public_ac";
        }
        return "";
      }

      function inferredNeed() {
        if (selections.scenario === "home_station") return "station";
        if (selections.scenario === "portable_charger") return "portable";
        if (selections.scenario === "adapter") return "adapt";
        return "";
      }

      var stages = Array.from(root.querySelectorAll("[data-stage]"));
      var summary = root.querySelector("[data-guide-summary]");
      var resultsGrid = root.querySelector("[data-guide-results-grid]");
      var resultsIntro = root.querySelector("[data-guide-results-intro]");
      var emptyState = root.querySelector("[data-guide-empty]");
      var sourceTitleNode = root.querySelector("[data-source-title]");
      var sourceCopyNode = root.querySelector("[data-source-copy]");

      function getSourcePrompt() {
        if (selections.scenario === "home_station") {
          return {
            title: "How will this station be installed?",
            copy: "Choose the power-input path for the home wallbox. For this guide, home charging station recommendations are treated as fixed-install hardware, not travel chargers."
          };
        }

        if (selections.scenario === "portable_charger") {
          return {
            title: "What outlet will you plug into?",
            copy: "Choose the real outlet or industrial socket the portable charger will use. This keeps the recommendation tied to the power source you actually have."
          };
        }

        if (selections.scenario === "adapter") {
          return {
            title: "What station connector are you adapting from?",
            copy: "Choose the charger-side or station-side connector first. Adapter recommendations should start from the source connector and end at your vehicle inlet."
          };
        }

        return {
          title: "What are you connecting to?",
          copy: "Choose only the relevant source side for the product form you picked: wall circuit, outlet, public AC station, public DC station, or charger-side connector."
        };
      }

      function renderSummary() {
        if (!summary) return;
        var chips = [];
        if (selections.scenario) chips.push(options.lookup.scenario[selections.scenario]);
        if (selections.vehicle) chips.push(options.lookup.vehicle[selections.vehicle]);
        if (selections.source) chips.push(options.lookup.source[selections.source]);

        if (!chips.length) {
          summary.innerHTML = "";
          return;
        }

        summary.innerHTML = chips
          .map(function (label) {
            return '<span class="cp-guide__summary-chip">' + label + "</span>";
          })
          .join("");
      }

      function renderOptions(stageKey, optionList, selectedValue) {
        var stage = root.querySelector('[data-stage-key="' + stageKey + '"]');
        if (!stage) return;
        var grid = stage.querySelector("[data-options-grid]");
        if (!grid) return;

        grid.innerHTML = optionList
          .map(function (item) {
            var isSelected = item.value === selectedValue;
            return (
              '<button type="button" class="cp-guide__option' +
              (isSelected ? " is-selected" : "") +
              '" data-option-value="' + item.value + '" data-option-stage="' + stageKey + '">' +
              '<span class="cp-guide__option-badge">' + item.badge + "</span>" +
              '<div class="cp-guide__option-title">' + item.title + "</div>" +
              '<div class="cp-guide__option-copy">' + item.copy + "</div>" +
              "</button>"
            );
          })
          .join("");
      }

      function updateStageHeaders() {
        var values = {
          scenario: selections.scenario ? options.lookup.scenario[selections.scenario] : "Choose the product form first",
          vehicle: selections.vehicle ? options.lookup.vehicle[selections.vehicle] : "Choose your EV charging inlet",
          source: selections.source ? options.lookup.source[selections.source] : "Choose the outlet, station, or source connector",
          results: selections.source ? "Best match preview ready" : "Results appear after the path is complete"
        };

        var toggles = {
          scenario: selections.scenario ? "Selected" : "Choose now",
          vehicle: selections.scenario ? (selections.vehicle ? "Selected" : "Ready") : "Locked",
          source: selections.vehicle ? (selections.source ? "Selected" : "Ready") : "Locked",
          results: selections.source ? "Results ready" : "Locked"
        };

        stages.forEach(function (stage, index) {
          var key = stage.getAttribute("data-stage-key");
          var activeIndex = activeStageIndex();
          var valueNode = stage.querySelector("[data-stage-value]");
          var toggleNode = stage.querySelector("[data-stage-toggle]");
          if (valueNode) valueNode.textContent = values[key] || "";
          if (toggleNode) toggleNode.textContent = toggles[key] || "";

          if (key === "results") {
            stage.setAttribute("data-state", activeIndex === 3 ? "active" : "locked");
            return;
          }

          if (index < activeIndex) {
            stage.setAttribute("data-state", "complete");
          } else if (index === activeIndex) {
            stage.setAttribute("data-state", "active");
          } else {
            stage.setAttribute("data-state", "locked");
          }
        });
      }

      function updateSourcePrompt() {
        var prompt = getSourcePrompt();
        if (sourceTitleNode) sourceTitleNode.textContent = prompt.title;
        if (sourceCopyNode) sourceCopyNode.textContent = prompt.copy;
      }

      function buildResultCards(matches) {
        if (!resultsGrid || !resultsIntro) return;

        resultsGrid.classList.remove("cp-guide__results-grid--single", "cp-guide__results-grid--double");

        if (!matches.length) {
          resultsIntro.textContent = selections.source
            ? "This exact path does not currently map to a recommended ChargePapa product. Adjust one step and try the closest technically correct route."
            : "Complete the path to see the strongest ChargePapa match.";
          resultsGrid.innerHTML = "";
          resultsGrid.setAttribute("data-result-count", "0");
          if (emptyState) emptyState.hidden = false;
          return;
        }

        resultsGrid.setAttribute("data-result-count", String(matches.length));
        if (matches.length === 1) {
          resultsGrid.classList.add("cp-guide__results-grid--single");
        } else if (matches.length === 2) {
          resultsGrid.classList.add("cp-guide__results-grid--double");
        }

        resultsIntro.textContent = "These routes match the path you just built. Review the fit summary, then continue into the strongest ChargePapa product path.";
        resultsGrid.innerHTML = matches
          .map(function (card) {
            var chips = [card.chip_1, card.chip_2, card.chip_3].filter(Boolean);
            var displayTitle = card.product_title || card.title;
            var productUrl = card.product_url || card.primary_cta_url;
            var primaryLabel = card.primary_cta_label || "View product";
            var cardHref = productUrl || card.secondary_cta_url || "";
            var media =
              card.image
                ? '<div class="cp-guide__result-media"><div class="cp-guide__result-media-frame"><img src="' + card.image + '" alt="' + displayTitle + '"></div></div>'
                : '<div class="cp-guide__result-media cp-guide__result-media--empty"><div class="cp-guide__result-media-note">Product image unavailable</div></div>';

            if (card.card_type === "product" && card.product_available === true) {
              if (card.product_has_only_default_variant === false) {
                primaryLabel = "Choose options";
              } else {
                primaryLabel = "View product";
              }
            }

            var priceMarkup = "";
            if (card.product_price || card.product_compare_at_price || card.price_label) {
              priceMarkup =
                '<div class="cp-guide__price-wrap">' +
                (card.product_compare_at_price ? '<span class="cp-guide__price cp-guide__price--compare">' + card.product_compare_at_price + "</span>" : "") +
                (card.product_price ? '<span class="cp-guide__price cp-guide__price--current">' + (card.product_price_varies ? "From " : "") + card.product_price + "</span>" : "") +
                (!card.product_price && card.price_label ? '<span class="cp-guide__price cp-guide__price--label">' + card.price_label + "</span>" : "") +
                "</div>";
            }
            return (
              '<article class="cp-guide__result-card">' +
              '<div class="cp-guide__result-shell">' +
              media +
              '<div class="cp-guide__result-content">' +
              (card.eyebrow ? '<div class="cp-guide__eyebrow">' + card.eyebrow + "</div>" : "") +
              '<h3 class="cp-guide__result-title">' +
              (cardHref ? '<a href="' + cardHref + '" class="cp-guide__result-link">' + displayTitle + "</a>" : displayTitle) +
              "</h3>" +
              (card.summary ? '<div class="cp-guide__result-summary">' + card.summary + "</div>" : "") +
              (chips.length ? '<div class="cp-guide__chips">' + chips.map(function (chip) { return '<span class="cp-guide__chip">' + chip + "</span>"; }).join("") + "</div>" : "") +
              priceMarkup +
              '<div class="cp-guide__actions">' +
              (productUrl ? '<a class="cp-guide__button button button--full-width" href="' + productUrl + '">' + primaryLabel + "</a>" : "") +
              (card.secondary_cta_url ? '<a class="cp-guide__button cp-guide__button--secondary button button--secondary button--full-width" href="' + card.secondary_cta_url + '">' + (card.secondary_cta_label || "See Collection") + "</a>" : "") +
              "</div>" +
              "</div>" +
              "</div>" +
              "</article>"
            );
          })
          .join("");

        if (emptyState) emptyState.hidden = true;
      }

      function filterResults() {
        var useCase = inferredUseCase();
        var need = inferredNeed();

        var matches = resultCards.filter(function (card) {
          return (
            card.match_use_case === useCase &&
            card.match_vehicle === selections.vehicle &&
            card.match_source === selections.source &&
            card.match_need === need
          );
        });

        buildResultCards(matches);
      }

      function rerender() {
        renderSummary();
        renderOptions("scenario", options.scenario, selections.scenario);
        renderOptions("vehicle", getVehicleOptions(), selections.vehicle);
        renderOptions("source", getSourceOptions(), selections.source);
        updateSourcePrompt();
        updateStageHeaders();
        filterResults();
      }

      function goBack(stageKey) {
        if (stageKey === "scenario") {
          selections.scenario = "";
          selections.vehicle = "";
          selections.source = "";
        } else if (stageKey === "vehicle") {
          selections.vehicle = "";
          selections.source = "";
        } else if (stageKey === "source") {
          selections.source = "";
        }

        rerender();
      }

      root.addEventListener("click", function (event) {
        var option = event.target.closest("[data-option-value]");
        if (option) {
          var stageKey = option.getAttribute("data-option-stage");
          var value = option.getAttribute("data-option-value");

          if (stageKey === "scenario") {
            selections.scenario = value;
            selections.vehicle = "";
            selections.source = "";
          } else if (stageKey === "vehicle") {
            selections.vehicle = value;
            selections.source = "";
          } else if (stageKey === "source") {
            selections.source = value;
          }

          rerender();
          return;
        }

        var completedStage = event.target.closest('[data-state="complete"]');
        if (completedStage) {
          goBack(completedStage.getAttribute("data-stage-key"));
          return;
        }

        var backButton = event.target.closest("[data-back-stage]");
        if (backButton) {
          goBack(backButton.getAttribute("data-back-stage"));
        }
      });

      rerender();
    });
  });
})();
